import {
  AUTH__RESET,
  BILLING_HISTORY__RESET,
  CONVERSATION__RESET,
  CUSTOMER_LEADS__RESET,
  DISPUTE__RESET,
  ONBOARDING__RESET,
  ORDER_SERVICES__RESET,
  PROFILE__RESET,
  PROPERTIES__RESET,
  REACTIVATION__RESET,
  RECOMMENDATIONS__RESET,
  REQUIRED_SERVICES__RESET,
  REVIEW__RESET,
  SERVICE_HISTORY__RESET,
  SCHEDULES__RESET,
  SHARE__RESET,
  SUPPORT__RESET,
  PROPERTY_MANAGER__RESET,
} from '@/store/types';

// eslint-disable-next-line import/prefer-default-export
export const LsAuthConstants = {
  mutationsToRunOnSignOut: [
    AUTH__RESET,
    BILLING_HISTORY__RESET,
    CONVERSATION__RESET,
    CUSTOMER_LEADS__RESET,
    DISPUTE__RESET,
    ONBOARDING__RESET,
    ORDER_SERVICES__RESET,
    PROFILE__RESET,
    PROPERTIES__RESET,
    REACTIVATION__RESET,
    RECOMMENDATIONS__RESET,
    REQUIRED_SERVICES__RESET,
    REVIEW__RESET,
    SCHEDULES__RESET,
    SERVICE_HISTORY__RESET,
    SHARE__RESET,
    SUPPORT__RESET,
    PROPERTY_MANAGER__RESET,
  ],
};
